import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m16.752 4.602-3.142-.698-.73 4.373c2.18.134 4.173.76 5.717 1.738a2.75 2.75 0 1 1 3.123 4.45q.03.265.03.535c0 1.986-1.207 3.692-2.97 4.867-1.768 1.178-4.167 1.883-6.78 1.883s-5.012-.705-6.78-1.883C3.457 18.692 2.25 16.986 2.25 15q0-.27.03-.535A2.75 2.75 0 0 1 3.5 9.25c.739 0 1.41.292 1.903.765 1.602-1.015 3.685-1.65 5.96-1.75l.897-5.388a.75.75 0 0 1 .903-.61l4.027.896a2.25 2.25 0 1 1-.438 1.44ZM8 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m9.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-8.376 3.584a.75.75 0 1 0-1.248.832c.306.46.875.778 1.52.986.673.216 1.546.348 2.604.348s1.93-.132 2.604-.348c.645-.208 1.214-.527 1.52-.986a.75.75 0 1 0-1.248-.832c-.027.041-.208.222-.73.39-.493.158-1.204.276-2.146.276s-1.653-.118-2.146-.276c-.522-.168-.703-.349-.73-.39",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSocialMediaReddit = { render };
export {
  brandSocialMediaReddit as default,
  render
};
//# sourceMappingURL=brand-social-media-reddit.svg.js.map
